import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { NgbAccordionModule, NgbDatepickerModule,NgbTooltipModule, NgbDropdownModule, NgbModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import { ViewDetailsCellRendererComponent } from './components/ag-grid-renderer/viewdetails-cell-renderer/viewdetails-cell-renderer.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { IconsComponent } from './components/ag-grid-icons/icons/icons.component';
import { CommonAgGridComponent } from './components/common-ag-grid/common-ag-grid.component';
import { AddWbUserComponent } from './components/add-wb-user/add-wb-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchComponent } from './components/search/search.component';
import { GoToDropdownComponent } from './components/go-to-dropdown/go-to-dropdown.component';
import { PopUpCellRendererComponent } from './components/pop-up-cell-renderer/pop-up-cell-renderer.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { MergedCellComponent } from './components/merged-cell/merged-cell.component';
import { MergedCellIconsComponent } from './components/merged-cell-icons/merged-cell-icons.component';
import { NgMultiSelectDropDown } from './components/ng-multiselect-dropdown/ng-multiselect-dropdown.module';
import { ToastComponent } from './components/toast/toast.component';
import { ToastService } from './services/toast-service/toast.service';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { ImageDropdownComponent } from './components/image-dropdown/image-dropdown.component';
import { HelpSlideout1Component } from './components/help-slideout/help-slideout.component';
import { ExtractFilenamePipe } from './pipes/extract-filename.pipe';
import { SendLetterApprovalComponent } from './components/send-letter-approval/send-letter-approval.component';
import { SendCodNotificationComponent } from './components/send-cod-notification/send-cod-notification.component';
import { ArFinalDeniedFormComponent } from './components/ar-final-denied-form/ar-final-denied-form.component';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { FileUploadComponentARreq } from './components/file-upload-recreditreq/file-upload-arreq.component';
import { ThirdPartySendLetterApprovalComponent } from './components/third-party-send-letter-approval/third-party-send-letter-approval.component';
import { ThirdPartyCodNotificationComponent } from './components/third-party-cod-notification/third-party-cod-notification.component';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { SidebarSalesComponent } from './components/sidebar-sales/sidebar-sales.component';
import { ClickableLinksDirective } from './directives/clickable-links.directive';
import { UploadCoiComponent } from './components/upload-coi/upload-coi.component';
import { UploadW9Component } from './components/upload-w9/upload-w9.component';
import { NotifyDeptComponent } from './components/notify-dept/notify-dept.component';
import { ProjectDocumentTabComponent } from './components/project-document-tab/project-document-tab.component';
import { StudioInquiryProjectInformationComponent } from './components/studio-inquiry-project-information/studio-inquiry-project-information.component';
import { StudioInquiryProductionCompanyComponent } from './components/studio-inquiry-production-company/studio-inquiry-production-company.component';
import { StudioInquiryStudioOperationsComponent } from './components/studio-inquiry-studio-operations/studio-inquiry-studio-operations.component';
import { StudioInquiryCostumesRentalsComponent } from './components/studio-inquiry-costumes-rentals/studio-inquiry-costumes-rentals.component';
import { StudioInquiryReviewComponent } from './components/studio-inquiry-review/studio-inquiry-review.component';
import { StudioInquiryConfirmationComponent } from './components/studio-inquiry-confirmation/studio-inquiry-confirmation.component';
import { StudioInquirySidebarComponent } from './components/studio-inquiry-sidebar/studio-inquiry-sidebar.component';

@NgModule({
  declarations: [
    LoaderComponent,
    ViewDetailsCellRendererComponent,
    PaginationComponent,
    IconsComponent,
    CommonAgGridComponent,
    AddWbUserComponent,
    SearchComponent,
    GoToDropdownComponent,
    PopUpCellRendererComponent,
    DatepickerComponent,
    MergedCellComponent,
    MergedCellIconsComponent,
    ToastComponent,
    UploadFileComponent,
    ImageDropdownComponent,
    HelpSlideout1Component,
    ExtractFilenamePipe,
    CurrencyFormatPipe,
    NumberFormatPipe,
    SendLetterApprovalComponent,
    SendCodNotificationComponent,
    ArFinalDeniedFormComponent,
    FileUploadComponentARreq,
    ThirdPartySendLetterApprovalComponent,
    ThirdPartyCodNotificationComponent,
    SanitizeHtmlPipe,
    SidebarSalesComponent,
    ClickableLinksDirective,
    UploadCoiComponent,
    UploadW9Component,
    NotifyDeptComponent,
    ProjectDocumentTabComponent,
    StudioInquirySidebarComponent,
    StudioInquiryProjectInformationComponent,
    StudioInquiryProductionCompanyComponent,
    StudioInquiryStudioOperationsComponent,
    StudioInquiryCostumesRentalsComponent,
    StudioInquiryReviewComponent,
    StudioInquiryConfirmationComponent
  ],
  imports: [
    CommonModule,
    NgbAccordionModule,
    NgbModule,
    AgGridModule,
    NgbDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    NgMultiSelectDropDown,
    NgbToastModule,
    NgbTooltipModule,
    NgbDropdownModule,
  ],
  providers:[ToastService],
  exports: [ LoaderComponent, PaginationComponent, SidebarSalesComponent , CommonAgGridComponent, PopUpCellRendererComponent,DatepickerComponent,SearchComponent,ToastComponent,UploadFileComponent,UploadW9Component,ImageDropdownComponent,HelpSlideout1Component, ExtractFilenamePipe, SendLetterApprovalComponent, SendCodNotificationComponent, ArFinalDeniedFormComponent, CurrencyFormatPipe, NumberFormatPipe,FileUploadComponentARreq, SanitizeHtmlPipe, ClickableLinksDirective, ProjectDocumentTabComponent, StudioInquirySidebarComponent, StudioInquiryProjectInformationComponent, StudioInquiryProductionCompanyComponent, StudioInquiryStudioOperationsComponent, StudioInquiryCostumesRentalsComponent, StudioInquiryReviewComponent, StudioInquiryConfirmationComponent]
})
export class SharedModule { }
